import IncidentSection5 from './IncidentSection5';

export default IncidentSection5;
